import { Component, OnInit } from '@angular/core';
import {select, Store} from '@ngrx/store';
import {GetFRConfigurations} from './store/actions/fr-actions';
import {FRConfigurationsSelector} from './store/selectors/fr-selectors';
import { IAppState } from 'app/IAppState';

@Component({
  selector: 'biz-connect-forms-recognizer',
  templateUrl: './connect-forms-recognizer.component.html',
  styleUrls: ['./connect-forms-recognizer.component.scss']
})
export class ConnectFormsRecognizerComponent implements OnInit {

  frConfigurations: IFormsRecognizer[];
  frConfigurations$:any;
  frConfigurationSub: any;
  selectedConfig : IFormsRecognizer;
  isLoading:boolean;
  constructor(private store: Store<IAppState>) {

  }

  ngOnInit() {
    this.isLoading = true;
    this.frConfigurations$ = this.store.pipe(select(FRConfigurationsSelector));
    this.frConfigurationSub =  this.frConfigurations$.subscribe((frConfigurations: IFormsRecognizer[])=>{
      if(frConfigurations && frConfigurations.length > 0){
        this.frConfigurations = frConfigurations.sort(function (a, b) {
          if (a.name > b.name) {
            return 1;
          }
          if (b.name > a.name) {
            return -1;
          }
          return 0;
        });;
        this.isLoading = false;
      }
      else{
        this.store.dispatch(new GetFRConfigurations())
      }
    })
    //this.store.dispatch(new GetSAPConfigurations())
  }

  cancelAction(){
    this.selectedConfig = null;
  }
  ngOnDestroy(){
    if(this.frConfigurationSub){
      this.frConfigurationSub.unsubscribe();
    }
  }

  applySelectConnector(config:IFormsRecognizer){
    this.selectedConfig = config;
  }

}
